import { FC, ReactNode, useState } from 'react';
import { IonButton } from '@ionic/react';
import { useBreakpoints } from '../theme/useBreakpoints';

interface ISlideButtonProps {
    onClick: () => boolean | Promise<void>;
    disabled?: boolean;
    children: ReactNode;
}

export const SlideButton: FC<ISlideButtonProps> = ({ onClick, disabled, children }) => {
    const { isBelowBreakpoint } = useBreakpoints();
    const padding = isBelowBreakpoint('sm') ? '0' : '0 50px';
    const [working, setWorking] = useState(false);

    const handleClick = async () => {
        setWorking(true);
        try {
            await onClick();
        } finally {
            setWorking(false);
        }
    };

    return (
        <IonButton expand="block" style={{padding, '--border-radius': '16px'}} disabled={disabled || working} onClick={handleClick}>
            {children}
        </IonButton>
    );
};
